import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BodegaService } from '../../services/bodega.service';
import { Bodega } from '../../model/bodega';

@Component({
  selector: 'app-bodega-mantenimiento',
  templateUrl: './bodega-mantenimiento.component.html',
  styleUrls: ['./bodega-mantenimiento.component.css']
})

export class BodegaMantenimientoComponent implements OnInit {

  @Input() bodegaSeleccionada: Bodega;
  @Output() onReturn = new EventEmitter();

  public bodega: Bodega = new Bodega();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public errorMessage: any;

  constructor(
    private _bodegaService: BodegaService,
  ) { }


  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    if (this.bodegaSeleccionada != null) {
      this.bodega = this.bodegaSeleccionada;
      this.estadoEditar = true;
    }

  }

  onSubmit() {
    if (this.bodega.id === undefined) {
      this.bodega.id = 0;
    }

    this._bodegaService.insert(this.bodega).subscribe(
      result => { 
        if(result.Resultado === "codigoBodega ya existe en la base de datos"){
            alert("El código de la Bodega ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.log(err._body);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._bodegaService.delete(this.bodega).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });

  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/bodega-mantenimiento/bodega-mantenimiento.component.ts